import * as _ from "lodash";

export const CapitalizeOnlyFirstLetter = (value: string) => {
  return _.startCase(_.toLower(value));
};

export const isEmpty = (value: string) => {
  return _.isEmpty(value);
};

export const getStringAbbrivation = (value: string): string => {
  if (!value) return "";

  const valueArrary = value.split(" ");

  const abbrivation = valueArrary
    .map((val) => (val.charAt(0) || "").toUpperCase())
    .join("");

  return abbrivation;
};
